import { Directive, OnInit } from '@angular/core';
import { PunchoutAuditListConfigBase } from '../../../services/punchout-audit-list-config.base';

/**
 * Shared behaviour of the two audit tabs: the date range and the refresh action.
 *
 * The list endpoint has no paging. Thus each tab limits its request by date. The first range is the
 * last month. The administrator makes the range wider to see older entries. Each visit starts again
 * with the last month.
 */
@Directive()
export abstract class PunchoutAuditTabBase implements OnInit {
  abstract readonly config: PunchoutAuditListConfigBase;

  fromDate = '';
  toDate = '';

  ngOnInit(): void {
    this.config.resetDateRange();
    const range = this.config.getDateRange();
    this.fromDate = range.from ?? '';
    this.toDate = range.to ?? '';
  }

  /**
   * True while the two dates give no usable range. The list service refuses such a range and keeps
   * the last result. The tab shows a hint to the administrator.
   */
  get rangeInvalid(): boolean {
    return !this.fromDate || !this.toDate || this.fromDate > this.toDate;
  }

  onFromDateChange(value: string): void {
    this.fromDate = value;
    this.config.setDateRange({ from: this.fromDate, to: this.toDate });
  }

  onToDateChange(value: string): void {
    this.toDate = value;
    this.config.setDateRange({ from: this.fromDate, to: this.toDate });
  }

  refresh(): void {
    this.config.refresh();
  }
}
